import React, { useEffect } from "react";
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import MainLayout from "./views/maindashboard/MainLayout";
import Login from "./views/Login/Login";

import Dashboard from "./views/Dashboard/dashboard";
import AddWorkReport from "./views/AddWorkReport/add_work_report";
import MyProjects from "./views/My Projects/my_projects";
import ProjectDetail from "./views/My Projects/project_detail";
import MyReports from "./views/My Reports/my_reports";
import Leave from "./views/Leave/leave";
import Profile from "./views/Profile/profile";
import Tasks from "./views/Tasks/tasks";
import Projects from "./views/Projects/Projects";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./App.css";
import Attendance from "./views/Attendance/Attendance";
import Holiday from "./views/Holiday/Holiday";
import Policy from "./views/Policy/Policy";

const ProtectedRoute = ({ children }) => {
  const employeeToken = localStorage.getItem("employeeToken");

  if (!employeeToken) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const PublicRoute = ({ children }) => {
  const employeeToken = localStorage.getItem("employeeToken");

  if (employeeToken) {
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  useEffect(() => {
    const handleLogoutSync = (event) => {
      // If employeeToken is cleared or the entire storage is cleared in another tab
      if (
        (event.key === "employeeToken" && !event.newValue) ||
        event.key === null
      ) {
        window.location.hash = "/login";
      }
    };

    window.addEventListener("storage", handleLogoutSync);
    return () => {
      window.removeEventListener("storage", handleLogoutSync);
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />

          <Route path="add-workreports" element={<AddWorkReport />} />
          <Route path="projects" element={<Projects />} />
          <Route path="attendance" element={<Attendance />} />
          <Route path="my-projects" element={<MyProjects />} />
          <Route path="project-detail" element={<ProjectDetail />} />
          <Route path="my-reports" element={<MyReports />} />
          <Route path="leave" element={<Leave />} />
          <Route path="tasks" element={<Tasks />} />
          <Route path="profile" element={<Profile />} />
          <Route path="holiday" element={<Holiday />} />
          <Route path="policy" element={<Policy />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </Router>
  );
}

export default App;
